import React from 'react'

const GlassSphereContext = React.createContext({})
export const GSProvider = GlassSphereContext.Provider
export const GSConsumer = GlassSphereContext.Consumer
export  default GlassSphereContext